import axios from "axios";
import { attachSentryResponseInterceptor } from "./sentryAxiosInterceptor";
import { AuthData } from "../types/types";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_RESEARCH_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const localAuth = localStorage.getItem("allaria-auth");
    const parsedLocalAuth: AuthData | null =
      (localAuth && JSON.parse(localAuth)) ?? null;
    const token = parsedLocalAuth?.access_token;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
attachSentryResponseInterceptor(axiosInstance);

export interface ApiFeature {
  name: string;
  enabled: boolean;
}

export const getFeatures = async () =>
  await axiosInstance.get<ApiFeature[]>(`/reports-manager/feature-configs`);

export const getFeature = async ({ name }: { name: string }) =>
  await axiosInstance.get<ApiFeature>(`/reports-manager/feature-configs`, {
    params: { feature_name: name },
  });

export const addFeature = async ({ feature }: { feature: ApiFeature }) =>
  await axiosInstance.post<ApiFeature>(`/reports-manager/feature-configs`, {
    body: feature,
  });

export const toggleFeature = async ({
  name,
  enabled,
}: {
  name: string;
  enabled: boolean;
}) =>
  // HACK: `params` config prop appears not to work on patch requests
  await axiosInstance.patch<ApiFeature>(
    `/reports-manager/feature-configs/${name}/status?enabled=${enabled}`
  );
